// 轮播图内容
export const banner = [
  {
    linkUrl: 'https://shop44558081.m.youzan.com/wscgoods/detail/2g41h587yp5g9',
    picUrl: require('assets/img/banner/1.png'),
  },
  {
    linkUrl: 'https://shop44558081.m.youzan.com/wscgoods/detail/3f454dgf9mdy1',
    picUrl: require('assets/img/banner/2.png'),
  },
];

// 主菜单列表
export const mainNavItems = [
  {
    linkUrl: '/audit/detail/1',
    picUrl: require('assets/img/menu/cj.png'),
    text: '初级会计',
  },
  {
    linkUrl: '/audit/detail/2',
    picUrl: require('assets/img/menu/zj.png'),
    text: '中级会计',
  },
  {
    linkUrl: '/audit/detail/3',
    picUrl: require('assets/img/menu/cpa.png'),
    text: '注册会计',
  },
  {
    linkUrl: '/audit/detail/4',
    picUrl: require('assets/img/menu/mat_cj.png'),
    text: 'MAT初级',
  },
  {
    linkUrl: '/audit/detail/13',
    picUrl: require('assets/img/menu/mat_zj.png'),
    text: 'MAT中级',
  },
  {
    linkUrl: '/audit/detail/5',
    picUrl: require('assets/img/menu/shicao.png'),
    text: '会计实操',
  },
];

// 站点导航
export const subNavItems = [
  {
    linkUrl: 'https://m.zhuokao360.com/plan/',
    picUrl: require('assets/img/menu/plan.png'),
    text: '学习计划',
  },
  {
    linkUrl: 'https://m.zhuokao360.com/know/',
    picUrl: require('assets/img/menu/know.png'),
    text: '必刷考点',
  },
  {
    linkUrl: 'https://m.zhuokao360.com/video/',
    picUrl: require('assets/img/menu/video.png'),
    text: '免费领课',
  },
  {
    linkUrl: 'https://m.zhuokao360.com/contact/',
    picUrl: require('assets/img/menu/contact.png'),
    text: '联系我们',
  },
];

// 新闻列表
export const news = [
  {
    poster: require('assets/img/news/cpa.png'),
    title: '这样学，CPA你也可以一年过六门！！',
    category: '注册会计',
    release_time: '2020-01-01',
    linkUrl: 'https://mp.weixin.qq.com/s/ZRRlOsCc-L51rbaVhYOP0Q',
  },
];
